<div class="container"
     [class.is-mobile]="mobileQuery.matches">

  <app-bar (toggleMenu)="snav.toggle()"></app-bar>

  <mat-sidenav-container class="side-container">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'">
      <app-menu *ngIf="meService.me$ | async"></app-menu>
    </mat-sidenav>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>

</div>

